
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { FormGroup } from '@angular/forms';


@Injectable({
  providedIn: 'root'
})
export class MessageService {

  constructor() { }


  erreurMsg : string = '';

  longueurMinimale : number = 0;

  messageObligatoire: string = 'Veuillez renseigner le champ ';

  traductionChampsFormulaire :  Map<string, string> = new Map([
    ['username', 'Email'],
    ['password', 'Mot de Passe'],
    ['lastname', 'Nom'],
    ['firstname', 'Prénom'],
    ['phoneNumber', 'Numéro Mobile'],
    ['typeUser', 'Type de Compte'],
    ['moypaieTyp', 'Mode de Paiement'],
    ['paiementMob', 'Moyen de Paiement Mobile'],
    ['acompteMnt', 'Montant a Acompte'],
    ['paieMnt', 'Montant a Payer'],
    ['ville', "Ville"],
    ['commune', "Commune"],
    ['comNom', "Commune"],
    ['adrQua', 'Quartier'],
    ['adrDsc', 'Détails Adresse (Localisation du lieu, Contact téléphonique)'],
    ['flgLivraisonEcole', 'Livraison Ecole)'],
    ['childName', "Nom et Prénoms de l'enfant"],
    ['expediteurid', "Expéditeur"],
    ['nom', "Nom"],
    ['nomExpediteur', "Nom Expéditeur"],
    ['prenom', "Prénoms"],
    ['telephone', "Numéro de Téléphone"],
    ['lieuDepartTexte', 'Adresse Expéditeur'],
    ['lieuDepartLongitude', 'Adresse Expéditeur'],
    ['lieuDepartLatitude', 'Adresse Expéditeur'],
    ['destinataireid', "Destinataire"],
    ['destinataireNom', "Nom Destinataire"],
    ['lieuArriveeTexte', 'Adresse Destinataire'],
    ['lieuArriveeLongitude', 'Adresse Destinataire'],
    ['lieuArriveeLatitude', 'Adresse Destinataire'],
    ['description', 'Description Article'],
    ['typeArticle', 'Type Article'],
    ['typeConditionnement', 'Type de Conditionnement'],
    ['quantite', 'Quantité'],
    ['poidsReel', 'Poids'],
    ['longueur', 'Longueur'],
    ['largeur', 'Largeur'],
    ['hauteur', 'Hauteur'],
    ['cmdMnt', 'Montant Commande'],
    ['dateLivraisonPrevue', "Date Prévisionnelle d'Enlèvement"],
    ['heureLivraisonPrevue', "Heure Prévisionnelle d'Enlèvement"],
    ['typeEnvoi', "Type de d'Envoi"],
    ['typePrestation', 'Type de Prestation'],
    ['montant', 'Montant Commande'],
    ['montantForfait', 'Montant Forfait'],
  ]);

  public gererErreur(erreur: HttpErrorResponse) {
    let msgErreur = '';
    const objMsgErreur = erreur.error;
    if (erreur.status === 0) {
      msgErreur = 'Serveur: impossible de se connecter ou requête incorrecte - Contactez l\'administrateur';
    } else if (erreur.status === 200) {
      msgErreur = '200';
    } else if (objMsgErreur && typeof objMsgErreur === 'object') {
      msgErreur = objMsgErreur.details ?? objMsgErreur.message ?? objMsgErreur.error ?? 'Une erreur est survenue';
    } else {
      msgErreur = typeof erreur.error === 'string' ? erreur.error : 'Une erreur est survenue';
    }
    return throwError(() => new Error(msgErreur));
  }


  obtenirMessageErreur(nomControle: string, nomErreur: string): string {
    
    var messageErreur : string = '';

    if(nomErreur == 'required') {
      messageErreur = nomControle.charAt(0).toUpperCase() + nomControle.slice(1);
    } else if(nomErreur == 'minLength') {
      messageErreur = "La taille minimum requise pour le champ '" + nomControle.slice(1) + "' est de " + this.longueurMinimale + " caractères, ";
    }
    
    return messageErreur;
  }

    
  obtenirErreursValidationFormulaire(formulaire : FormGroup): string {
    var erreurs: string = '';

    Object.keys(formulaire.controls).forEach((cle) => {
      const controle = formulaire.get(cle);
      const erreursControle = formulaire.get(cle)?.errors;
      if (erreursControle) {
        if (cle != undefined && controle != undefined && controle != null && controle.hasError('required')) {

          if(this.traductionChampsFormulaire.get(cle) != undefined) {
            erreurs = erreurs.concat("Veuillez renseigner le champ « " + this.traductionChampsFormulaire.get(cle) + " », ").concat("\r\n");
          } else {
            erreurs = erreurs.concat("Veuillez renseigner le champ « " + cle + " », ").concat("\r\n");
          }
          
        } else {
          erreurs = erreurs.concat("Veuillez vérifier le champ « " + this.traductionChampsFormulaire.get(cle) + " », ").concat("\r\n");
        }
       
      }
    }); 

    return erreurs;
  }


  afficherMessageErreur(erreur: any) : string{
    if(erreur.message === '200') {
      return 'OK';
    } else {
      if(erreur.status == 0) {
        return "La requete a échoué: Contactez l'administrateur.";
      } else {
        if(erreur.message != undefined && erreur.message != '') {
          if(erreur.error != undefined && erreur.error != '') {
            return erreur.error;
          } else {
            return erreur.message;
          }
        } else {
          if(erreur.status != undefined && erreur.status != '') {
            return erreur.error;
          } else {
            return erreur;
          }
        }
      }

    }
  }

}
